import React from "react";
import { useForm } from "react-hook-form";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormFeedback,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap";
import { toast } from "react-toastify";
import Breadcrumbs from "../../coreComponents/breadcrumbs";
import ApiService from "../../services/apiService";

interface DeviceForm {
  duid: string;
  deviceType: string;
  deviceName: string;
  modelNumber: string;
  modelVersion: string;
  firmwareVersion: string;
  manufacturingDate: string;
  manufacturingLocation: string;
  deviceKey: string;
  numberOfInstrument: number;
}

const AddDevices = () => {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isSubmitting },
  } = useForm<DeviceForm>({
    mode: "onChange",
    reValidateMode: "onChange",
    defaultValues: {
      duid: "",
      deviceType: "",
      deviceName: "",
      modelNumber: "",
      modelVersion: "",
      firmwareVersion: "",
      manufacturingDate: "",
      manufacturingLocation: "",
      deviceKey: "",
      numberOfInstrument: 0,
    },
  });

  const postDeviceDetails = async (data: DeviceForm) => {
    try {
      const payload = {
        ...data,
        manufacturingDate: data.manufacturingDate
          ? new Date(data.manufacturingDate).toISOString()
          : null,
      };
      console.log(payload);
      const res = await ApiService.axiosApi("/devicemaster/create", {
        method: "POST",
        data: payload,
      });

      if (res.success) {
        toast.success("Device Added Successfully");
        reset();
      } else {
        console.log(res);
        toast.error("Failed to Add Device");
      }
    } catch (error) {
      console.error(error);
      toast.error("Something went wrong");
    }
  };

  return (
    <Container fluid>
      <Breadcrumbs mainTitle="Add Device" parent="Device Master" />

      <Card>
        <CardBody>
          <Form onSubmit={handleSubmit(postDeviceDetails)}>
            <Row>
              {/* DUID */}
              <Col md="6">
                <FormGroup>
                  <Label>DUID</Label>
                  <Input
                    type="text"
                    placeholder="Enter DUID"
                    invalid={!!errors.duid}
                    {...register("duid", {})}
                  />
                  <FormFeedback>{errors.duid?.message}</FormFeedback>
                </FormGroup>
              </Col>

              {/* Device Type */}
              <Col md="6">
                <FormGroup>
                  <Label>Device Type</Label>
                  <Input
                    type="text"
                    placeholder="Enter Device Type"
                    invalid={!!errors.deviceType}
                    {...register("deviceType")}
                  />
                  <FormFeedback>{errors.deviceType?.message}</FormFeedback>
                </FormGroup>
              </Col>

              {/* Device Name */}
              <Col md="6">
                <FormGroup>
                  <Label>Device Name</Label>
                  <Input
                    type="text"
                    placeholder="Enter Device Name"
                    invalid={!!errors.deviceName}
                    {...register("deviceName")}
                  />
                  <FormFeedback>{errors.deviceName?.message}</FormFeedback>
                </FormGroup>
              </Col>

              {/* Model Number */}
              <Col md="6">
                <FormGroup>
                  <Label>Model Number</Label>
                  <Input
                    type="text"
                    placeholder="Enter Model Number"
                    {...register("modelNumber")}
                  />
                </FormGroup>
              </Col>

              {/* Model Version */}
              <Col md="6">
                <FormGroup>
                  <Label>Model Version</Label>
                  <Input
                    type="text"
                    placeholder="Enter Model Version"
                    {...register("modelVersion")}
                  />
                </FormGroup>
              </Col>

              {/* Firmware Version */}
              <Col md="6">
                <FormGroup>
                  <Label>Firmware Version</Label>
                  <Input
                    type="text"
                    placeholder="Enter Firmware Version"
                    {...register("firmwareVersion")}
                  />
                </FormGroup>
              </Col>

              {/* Manufacturing Date */}
              <Col md="6">
                <FormGroup>
                  <Label>Manufacturing Date</Label>
                  <Input type="date" {...register("manufacturingDate")} />
                </FormGroup>
              </Col>

              {/* Manufacturing Location */}
              <Col md="6">
                <FormGroup>
                  <Label>Manufacturing Location</Label>
                  <Input
                    type="text"
                    placeholder="Enter Manufacturing Location"
                    {...register("manufacturingLocation")}
                  />
                </FormGroup>
              </Col>

              {/* Device Key */}
              <Col md="6">
                <FormGroup>
                  <Label>Device Key</Label>
                  <Input
                    type="text"
                    placeholder="Enter Device Key"
                    {...register("deviceKey")}
                  />
                </FormGroup>
              </Col>

              {/* Number of Instruments */}
              <Col md="6">
                <FormGroup>
                  <Label>Number Of Instruments</Label>
                  <Input
                    type="number"
                    placeholder="Enter Number Of Instruments"
                    {...register("numberOfInstrument", {
                      valueAsNumber: true,
                    })}
                  />
                </FormGroup>
              </Col>

              <Col md="12" className="text-end">
                <Button color="primary" type="submit" disabled={isSubmitting}>
                  {isSubmitting ? "Saving..." : "Save Device"}
                </Button>
              </Col>
            </Row>
          </Form>
        </CardBody>
      </Card>
    </Container>
  );
};

export default AddDevices;
